import React, { useContext } from "react";
import * as styles from "./component.module.less";
import { Button } from "../../Button";
import { generateClassString as gcs } from "../../../lib/helper/generateClassString";
import CookieContext from "../../CookieContext";
import t from "../../../lib/translate";
import { CookieFunktions } from "../CookieFunctions/CookieFunktions";

export default function CookieBannerHeader({
    currentPage,
    setCurrentPage,
    settingsTitle,
    cookieGroupId,
    groupFunctions,
    title
}) {
    const isSettingsPage = "settings" === currentPage;

    const { checkedSwitches, toggleSwitches } = useContext(CookieContext);
    const isActive = checkedSwitches.includes(cookieGroupId);

    return (
        <div className={styles.cookieGroupHeader}>
            {!isSettingsPage && (
                <CookieFunktions functions={groupFunctions} active={isActive} />
            )}
            <Button
                className={styles.backButton}
                type="secondary"
                onClick={() => {
                    isSettingsPage
                        ? setCurrentPage("main")
                        : setCurrentPage("settings");
                }}
                icon="chevronLeft"
                iconPosition="left"
            >
                {t("cookie.back-button")}
            </Button>
            <div className={styles.headlineSwitchContainer}>
                <h4>{isSettingsPage ? settingsTitle : title}</h4>
                <div className={styles.switchBlock}>
                    <input
                        checked={isActive}
                        type="checkbox"
                        disabled={cookieGroupId === "*"}
                        onChange={() =>
                            toggleSwitches({
                                type: "switch",
                                key: cookieGroupId
                            })
                        }
                    />
                    {!isSettingsPage && (
                        <div
                            className={gcs(styles.switchMark, [
                                cookieGroupId === "*",
                                styles.switchCheckedInactive
                            ])}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}
